const enum PositionStatus {
  Open = 'Open',
  Closed = 'Closed',
  Interviewing = 'Interviewing',
  OfferSent = 'OfferSent',
  Deactivated = 'Deactivated',
}
export default PositionStatus;
